import React from 'react'
import { Box, Typography, Card, CardContent, Chip, Button, useTheme } from '@mui/material'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import PersonIcon from '@mui/icons-material/Person'
import EmailIcon from '@mui/icons-material/Email'

const ResidencyTransferCard = ({ transfer }) => {
  const theme = useTheme()
  
  const handleContact = () => {
    window.location.href = `mailto:${transfer.email}?subject=Residency Transfer Inquiry`
  }
  
  return (
    <Card 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        '&:hover': {
          boxShadow: 3,
          transform: 'translateY(-2px)',
          transition: 'all 0.2s ease-in-out'
        }
      }}
    >
      <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5, justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <PersonIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              {transfer.pgyLevel}
            </Typography>
          </Box>
          {transfer.programLocation && (
            <Typography 
              variant="body2" 
              color="textSecondary"
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                backgroundColor: theme.palette.grey[50],
                px: 1,
                py: 0.5,
                borderRadius: 1,
              }}
            >
              <LocationOnIcon fontSize="small" sx={{ mr: 0.5 }} />
              {transfer.programLocation}
            </Typography>
          )}
        </Box>

        <Box sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center',
          gap: 1
        }}>
          <Box>
            <Typography variant="body2" color="textSecondary" align="center" gutterBottom>
              Current Program
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, justifyContent: 'center' }}>
              {transfer.currentProgram ? (
                <Chip 
                  label={transfer.currentProgram}
                  size="small"
                  sx={{ 
                    backgroundColor: theme.palette.grey[200],
                    color: theme.palette.text.primary,
                  }}
                />
              ) : (
                <Chip 
                  label="Unmatched"
                  size="small"
                  sx={{ 
                    backgroundColor: theme.palette.grey[100],
                    color: theme.palette.text.secondary,
                  }}
                />
              )}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', my: 0.5 }}>
            <SwapHorizIcon color="primary" />
          </Box>

          <Box>
            <Typography variant="body2" color="textSecondary" align="center" gutterBottom>
              Desired Program
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, justifyContent: 'center' }}>
              {transfer.desiredPrograms?.map((program, index) => (
                <Chip 
                  key={index}
                  label={program}
                  size="small"
                  sx={{ 
                    backgroundColor: theme.palette.grey[200],
                    color: theme.palette.text.primary,
                  }}
                />
              ))}
            </Box>
          </Box>
        </Box>

        <Box sx={{ 
          mt: 1.5,
          pt: 1.5,
          borderTop: `1px solid ${theme.palette.grey[200]}`,
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <Button 
            variant="outlined"
            size="small"
            startIcon={<EmailIcon />}
            onClick={handleContact}
            sx={{
              borderColor: theme.palette.primary.main,
              '&:hover': {
                backgroundColor: theme.palette.primary.light,
                borderColor: theme.palette.primary.main,
              }
            }}
          >
            Contact
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}

export default ResidencyTransferCard 